/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:35:55
 * @LastEditTime: 2021-01-27 10:25:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\store\getters.js
 */
const getters = {
	sidebar: state => state.app.sidebar,
	language: state => state.app.language,
	device: state => state.app.device,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	name: state => state.user.name,
	roles: state => state.user.roles,
	permission_routes: state => state.permission.routes,
	newMsg: state => state.newMsg
}
export default getters
